import { render, staticRenderFns } from "./EmailContact.vue?vue&type=template&id=1e36bf83&scoped=true"
import script from "./EmailContact.vue?vue&type=script&lang=js"
export * from "./EmailContact.vue?vue&type=script&lang=js"
import style0 from "./EmailContact.vue?vue&type=style&index=0&id=1e36bf83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e36bf83",
  null
  
)

export default component.exports